<div class="grid grid-cols-12 gap-4">
  <div class="col-span-12">
    <microsec-card [isNestedCard]="true" [isTableCard]="true">
      <microsec-common-table
        #dt
        [cols]="selectedCols"
        [values]="devices"
        itemName="Device"
        [(selection)]="selectedDevice"
        [cellTemplate]="cellTemplate">
      </microsec-common-table>
    </microsec-card>
  </div>
</div>

<ng-template let-col="col" let-rowData="rowData" #cellTemplate>
  <ng-container [ngSwitch]="col.field">
    <!-- MAC Address -->
    <ng-container *ngSwitchCase="'mac_address'">
      <span [pTooltip]="isArray(rowData[col.field]) ? rowData[col.field].join(', ') : ''" tooltipPosition="top" appendTo="body">
        {{ isArray(rowData[col.field]) ? rowData[col.field][0] : '-' }}
      </span>
    </ng-container>
    <!-- IP Addresses -->
    <ng-container *ngSwitchCase="'ip_address'">
      <span [pTooltip]="isArray(rowData[col.field]) ? rowData[col.field].join(', ') : ''" tooltipPosition="top" appendTo="body">
        {{ isArray(rowData[col.field]) ? rowData[col.field][0] : '-' }}
      </span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="overflow-hidden whitespace-nowrap text-ellipsis">
        {{ rowData[col.field] || '-' }}
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<p-drawer
  [(visible)]="displayDeviceDetails"
  [showCloseIcon]="false"
  [style]="{ width: '50rem' }"
  position="right"
  appendTo="body"
  [baseZIndex]="998"
  (onHide)="selectedDevice = null">
  @if (!!selectedDevice && !!displayDeviceDetails) {
    <app-shared-detected-device-details [deviceId]="selectedDevice.device_id" (hidePanelEvent)="selectedDevice = null" />
  }
</p-drawer>
